__turbopack_context__.v({
  "active": "MobileMenu-module__OvyhTG__active",
  "hamburger-menu": "MobileMenu-module__OvyhTG__hamburger-menu",
  "hamburger-menu__lines": "MobileMenu-module__OvyhTG__hamburger-menu__lines",
  "menu-link": "MobileMenu-module__OvyhTG__menu-link",
});
